import React from 'react'
import { default as ReactTimeago } from 'react-timeago'
interface TimeagoProps {
	date: Date | string
}
const Timeago: React.FC<TimeagoProps> = ({ date }) => (
	<ReactTimeago date={date}></ReactTimeago>
)
export default Timeago
